(() => {
  'use strict';
  if (window.taffstyleScrollReveal || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  window.taffstyleScrollReveal = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tracked = new WeakSet();
  const animations = new Set();
  const selector = '.ts-category, .ts-editorial__row, .ts-materials__item, .ts-links__grid > li, .dp-benefit, .dp-topic, .dp-gallery > div, .dp-gallery > article, .dp-gallery > a';
  let observer;
  const start = (scope = document) => {
    if (motion.matches || (window.Shopify && window.Shopify.designMode)) return;
    const content = document.getElementById('content');
    if (!content) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (motion.matches || document.hidden || entry.boundingClientRect.bottom <= 0) return;
        const visibleSiblings = Array.from(entry.target.parentElement.children).filter(el => el.matches(selector));
        const delay = Math.min(Math.max(visibleSiblings.indexOf(entry.target), 0) % 3, 2) * 40;
        const animation = entry.target.animate(
          [{ opacity: 0.3, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 400, delay, easing: 'cubic-bezier(0.2, 0.65, 0.3, 1)', fill: 'backwards' }
        );
        animations.add(animation);
        animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
      });
    }, { threshold: 0 });
    scope.querySelectorAll(selector).forEach(el => {
      if (tracked.has(el) || !content.contains(el) || el.closest('footer, #footer, .shopify-section-footer, [hidden], dialog, details:not([open])')) return;
      if (el.parentElement.closest(selector)) return;
      const rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      tracked.add(el);
      if (rect.top >= window.innerHeight + 24) observer.observe(el);
    });
  };
  motion.addEventListener('change', () => {
    if (motion.matches) {
      if (observer) observer.disconnect();
      animations.forEach(animation => animation.cancel());
      animations.clear();
    } else start();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
